import React, { useEffect, useState } from "react";
import { Question } from "./Question";
import { Answer } from "./Answer";
import { End } from "./End";

export const Quiz = (props) => {
    const [currentStep, setCurrentStep] = useState(0);
    const [score, setScore] = useState(0);
    const [scoreMaxTotal, setScoreMaxTotal] = useState(0);
    const [answerData, setAnswerData] = useState(null);
    const [answerStatus, setAnswerStatus] = useState(null);

    const checkAnswers = (userAnswers) => {
        fetch(`/api/${props.quizId}/${props.data[currentStep].id}`)
            .then(res => res.json())
            .then(res => {
                let forgotten = res.correctAnswers.filter(correctAnswer => !userAnswers.includes(correctAnswer));
                let incorrect = userAnswers.filter(userAnswer => !res.correctAnswers.includes(userAnswer));
                let status = 'danger';
                if(forgotten.length > 0 && incorrect == 0){
                    status = 'warning';
                    setScore(score + res.answer.scoreMax/2)
                }
                if(forgotten.length == 0 && incorrect == 0){
                    status = 'success';
                    setScore(score + res.answer.scoreMax);
                }
                setAnswerStatus(status);
                setAnswerData(res.answer);
                setScoreMaxTotal(scoreMaxTotal + res.answer.scoreMax);
            })
    }

    const nextQuestion = () => {
        if ((currentStep + 1) === props.data.length) {
            try {
                tc_events_global(this, 'click', {'evt_click_name': 'voir-le-resultat'});
            } catch (error) {
                console.error(error);
            }
        }
        setAnswerData(null);
        setAnswerStatus(null);
        setCurrentStep(currentStep + 1);
    }

    useEffect(() => {
        currentStep == props.data.length && fetch('/api/quiz-clean')
    }, [currentStep])

    return (
        <div>
            {currentStep < props.data.length &&
                <div class="mb-5">
                    <div className="container">
                        <div className="wizard-progress"> 
                            <h1>
                                <span class="step">Quiz : Aux Alentours par MAIF</span>
                                <span className="unit">
                                    {currentStep + 1}<span aria-hidden="true">/</span><span className="sr-only">sur </span>{props.data.length}</span>
                            </h1>
                            <progress className="wizard-progress-bar" max={props.data.length} aria-hidden="true" value={currentStep + 1}></progress>
                        </div>
                    </div>
                </div>
            } 
            {currentStep < props.data.length ?
                <div className="container mb-5">
                    <Question data={props.data[currentStep]} sendAnswers={checkAnswers} isAnswerOpen={answerData && answerStatus}/>
                    {answerData && answerStatus &&
                        <Answer
                            answerStatus={answerStatus}
                            answerData={answerData}
                            onClose={nextQuestion}
                            coordinates={props.coordinates}
                            isFinalQuestion={(currentStep + 1) === props.data.length}
                        />
                    }
                </div>
                :
                <>
                    <End percentage={score/scoreMaxTotal*100} quizId={props.quizId} sharingUrl={props.sharingUrl} pdfReportUrl={props.pdfReportUrl} address={props.coordinates.address}/>
                </>
            }
        </div>
    )
}